import axios from "axios";

import router from "./router";

import message from '@/common/js/message'

import Load from 'common/js/loading'

import { getToken, deleteToken, delTags } from "common/js/storage";

// 请求接口数目
let allResquest = 0

// axios 配置
axios.defaults.timeout = 1800000;

// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.headers["Content-Type"] = "application/json";
    let token = getToken();
    if (token) {
      // 将token设置成请求头
      config.headers["Auth-Token"] = token;
    }
    allResquest = allResquest + 1 
    Load.loading()
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 响应器
axios.interceptors.response.use(
  response => {
    allResquest = allResquest - 1
    if (allResquest === 0) {
      Load.hideLoading();
    }
    // 接口请求成功以后的报错信息(排除接口请求文件流和上传图片)
    if (!response.data.success && response.data.message !== undefined && response.request.responseType !== 'blob'&& !response.data.accessid && response.data !== '') {
      message.error(response.data.message);
    }
    // 登录过期或非法令牌跳转登录页
    if (response.data.code === 401) {
      deleteToken()
      delTags()
      router.replace({
        path: "/login"
      });
    }
    return response;
  },
  err => {
    allResquest = allResquest - 1
    Load.hideLoading();
    console.log('http',err);
    return Promise.reject(err);
  }
);

export default axios;
